//#region src/schema/discriminator-metadata.ts
var e = Symbol("schema-discriminator");
//#endregion
export { e as schemaDiscriminator };

//# sourceMappingURL=discriminator-metadata.js.map